import { slugify } from "@certn/utils";

import { Select } from "../select/Select";
import { SelectItem } from "../select/SelectItem";

export type DateSegmentProps = {
  input: string;
  selectedKey: number | undefined;
  setValue: (e: number) => void;
  options: any[];
  placeholder: string;
  isDisabled?: boolean;
  isRequired?: boolean;
  isInvalid?: boolean;
  onBlur?: () => void;
  onFocus?: () => void;
  testID?: string;
};

export const DateSelectSegment = (props: DateSegmentProps) => {
  const { selectedKey, input, setValue, options, placeholder, ...rest } = props;

  return (
    <Select
      testID={`${slugify(placeholder)}-select-segment`}
      selectedKey={selectedKey?.toString() ?? null}
      aria-label={placeholder}
      placeholder={placeholder}
      onSelectionChange={(key) => setValue(Number(key))}
      isInvalid={props.isInvalid}
      isRequired={props.isRequired}
      {...rest}
    >
      {!props.isRequired && (
        <SelectItem
          aria-label="empty"
          key="empty-option"
          data-testid="select-option-empty"
          id="empty"
        >
          {placeholder}
        </SelectItem>
      )}
      {options.map((item: number, index: number) => {
        // we don't want to submit February in french as a value
        // we also want index 0 to be day 1 and month 1
        let value = item;
        if (["m", "d"].includes(input)) value = index + 1;
        return (
          <SelectItem
            aria-label={item.toString()}
            key={value}
            data-testid={`select-option-${value}`}
            id={value?.toString()}
          >
            {item.toString()}
          </SelectItem>
        );
      })}
    </Select>
  );
};
